import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="modal"
export default class extends Controller {
  static targets = ["passwordModal"]

  close(event) {
    if (event.detail.success) {
      this.element.style.display = "none";
    }
  }

  openModalUser(event) {
    event.preventDefault();
    this.passwordModalTarget.classList.remove('hidden');
    setTimeout(() => {
      this.passwordModalTarget.classList.add('opacity-100');
    }, 10);
  }

  closeModalUser(event) {
    event.preventDefault();
    this.passwordModalTarget.classList.remove('opacity-100');
    setTimeout(() => {
      this.passwordModalTarget.classList.add('hidden');
    }, 300);
  }
}
